import type { Modifier } from '@dnd-kit/core';

export function dropIndex(ids: string[], activeId: string, overId: string): number | null {
  if (activeId === overId) return null;
  const from = ids.indexOf(activeId);
  const to = ids.indexOf(overId);
  if (from < 0 || to < 0) return null;
  return to;
}

export function orderByFrozenIds<T extends { id: string }>(items: T[], frozenIds: string[] | null): T[] {
  if (!frozenIds) return items;
  const byId = new Map(items.map(item => [item.id, item]));
  const frozenSet = new Set(frozenIds);
  const kept = frozenIds.map(id => byId.get(id)).filter((item): item is T => item !== undefined);
  const added = items.filter(item => !frozenSet.has(item.id));
  return [...kept, ...added];
}

export function transformToCss(
  transform: { x: number; y: number; scaleX: number; scaleY: number } | null,
): string | undefined {
  if (!transform) return undefined;
  return `translate3d(${transform.x}px, ${transform.y}px, 0) scaleX(${transform.scaleX}) scaleY(${transform.scaleY})`;
}

export const lockToVerticalAxis: Modifier = ({ transform }) => ({ ...transform, x: 0 });
